import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import DriveItemsButton from "@/components/DriveItemsButton.vue";
import { MimeType } from "../enums";
import { GraphApiUtils } from '@/utils/graphApiUtils';

@Component({
	components: {
		DriveItemsButton
	}
})
export default class BucketItem extends Vue {
	@Prop() public id!: string;
	@Prop() public name!: string;
	@Prop() public dateString!: string;
	@Prop() public disabled!: boolean;
	@Prop() public isVisibleButtonContainer!: boolean;
	@Prop() public driveItemsButtons!: DriveItemsButton[];
	@Prop() public isVisibleIcon!: boolean;
	@Prop() public isVisibleIndicator!: boolean;

	@Emit("bucket-item-click")
	public clickItem(id: string) { }

	@Emit("drive-items-button-click")
	public clickDriveItemsButton(bucketId: string, path: string, mimeType: MimeType) { }

	public async created(): Promise<void> {
		if (!await GraphApiUtils.isValidAccessToken(Vue.$accessTokenInfo)) {
			// TODO ルーティング
			return;
		}
	}

	@Watch('name')
	private onNameChanege(newName: string, oldName: string): void { }

	private onItemClick(): void {
		this.clickItem(this.id);
	}

	private onDriveItemsButtonClick(path: string, mimeType: MimeType): void {
		this.clickDriveItemsButton(this.id, path, mimeType);
	}
}
